import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { UserLoginApi } from "../../Services/Auth/Login";
import { image_baseurl } from "../../../Utils/config";
import { Link } from "react-router-dom";
import { basicsettinglist } from "../../Services/Admin/Admin";
import $ from "jquery";
import BgImg from "./bg-login-img.png";
import showCustomAlert from "../../Extracomponents/CustomAlert/CustomLogin";
import { UserPhoneNumberLogin, UserVerifyOtp } from "../../Services/Auth/Login";
import ReusableModal from "../../components/Models/ReusableModal";

const Userlogin = () => {
  const theme = localStorage.getItem("theme");
  const [themeBackground, setThemeBackground] = useState("#ffffff");
  const [loginMethod, setLoginMethod] = useState("otp"); 

  useEffect(() => {
    if (theme) {
      try {
        const parsedTheme = JSON.parse(theme);
        const bgColor = parsedTheme?.sidebarColor || "#ffffff";
        setThemeBackground(bgColor);
      } catch (err) {
        console.error("Theme parse error", err);
      }
    }
  }, []);

  const navigate = useNavigate();
  const [email, setemail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [information, setInformation] = useState([]);

  const [phone, setPhone] = useState("");
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const [enteredOtp, setEnteredOtp] = useState("");

  const [resendTimer, setResendTimer] = useState(30);
  const [canResendOtp, setCanResendOtp] = useState(false);

  const inputRefs = useRef([]);

  const togglePasswordVisibility = (e) => {
    e.preventDefault();
    setShowPassword(!showPassword);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (isLoading) return;
    if (email.trim() === "" || password.trim() === "") {
      showCustomAlert(
        "error",
        "Please enter both email and password",
        navigate,
        null,
      );
      return;
    }

    setIsLoading(true);
    const ResData = await UserLoginApi({ UserName: email, password: password });
    setIsLoading(false);

    if (ResData.status) {
      localStorage.setItem("token", ResData.data?.token);
      localStorage.setItem("id", ResData.data?.id);
      localStorage.setItem("Role", "USER");
      localStorage.setItem("aliceredirecturl", ResData.data?.aliceredirecturl);
      localStorage.setItem("angleredirecturl", ResData.data?.angleredirecturl);
      localStorage.setItem(
        "upstoxredirecturl",
        ResData.data?.upstoxredirecturl,
      );
      localStorage.setItem(
        "zerodharedirecturl",
        ResData.data?.zerodharedirecturl,
      );

      showCustomAlert(
        "success",
        "Login successful!",
        navigate,
        "/user/dashboard",
      );
    } else {
      showCustomAlert("error", ResData.message, navigate, null);
    }
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();
    if (isLoading) return;

    if (!phone) {
      showCustomAlert("error", "Please enter phone number");
      return;
    }

    setIsLoading(true);

    try {
      const res = await UserPhoneNumberLogin({
        PhoneNo: phone,
        token: null,
        utmSource: null,
      });

      setIsLoading(false);

      if (res.status) {
        showCustomAlert("success", "OTP sent successfully");
        setIsOtpModalOpen(true);
      } else {
        showCustomAlert("error", res.data.message);
      }
    } catch (err) {
      console.log("error", err);
      setIsLoading(false);
      showCustomAlert("error", err.response.data.message);
    }
  };

  const handleOtpVerify = async () => {
    if (isLoading) return;
    if (!enteredOtp || enteredOtp.length !== 6) {
      showCustomAlert("error", "Enter valid OTP");
      return;
    }

    try {
      setIsLoading(true);
      const res = await UserVerifyOtp({
        otp: enteredOtp,
        PhoneNo: phone,
        devicetoken: null,
      });
      setIsLoading(false);

      if (res.status) {
        localStorage.setItem("token", res.data?.token);
        localStorage.setItem("id", res.data?.id);
        localStorage.setItem("Role", "USER");

        showCustomAlert(
          "success",
          "Login successful!",
          navigate,
          "/user/dashboard",
        );

        setIsOtpModalOpen(false);
      } else {
        showCustomAlert("error", res.message || "Invalid OTP");
      }
    } catch (err) {
      setIsLoading(false);
      showCustomAlert("error", "OTP verification failed");
    }
  };

  const getsettinglist = async () => {
    try {
      let token = "";
      const response = await basicsettinglist(token);
      if (response.status) {
        localStorage.setItem("theme", JSON.stringify(response?.Theme));

        const faviconElement = document.querySelector("link[rel='icon']");
        if (faviconElement) {
          faviconElement.href =
            image_baseurl + "uploads/basicsetting/" + response.data[0].favicon;

          $(".companyName").html(response.data[0].from_name);
        } else {
          console.log("Favicon element not found");
        }

        setInformation(response.data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getsettinglist();
  }, []);

  const handleResendOtp = async () => {
    if (!canResendOtp || isLoading) return;
    setResendTimer(30);
    setCanResendOtp(false);

    if (!phone) {
      showCustomAlert("error", "Phone number missing");
      return;
    }

    setIsLoading(true);

    try {
      const res = await UserPhoneNumberLogin({
        PhoneNo: phone,
        token: null,
        utmSource: null,
      });

      setIsLoading(false);

      if (res.status) {
        showCustomAlert("success", "OTP resent successfully");
        setEnteredOtp("");
        inputRefs.current[0]?.focus();
      } else {
        showCustomAlert("error", res.data.message);
      }
    } catch (err) {
      setIsLoading(false);
      showCustomAlert("error", "Failed to resend OTP");
    }
  };

  useEffect(() => {
    if (!isOtpModalOpen || canResendOtp) return;

    const interval = setInterval(() => {
      setResendTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setCanResendOtp(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isOtpModalOpen, canResendOtp]);

  return (
    <div
      className="main-login"
      style={{
        background: themeBackground,
        minHeight: "100vh",
        width: "100%",
        transition: "background 0.4s ease-in-out",
      }}
    >
      <div className="row align-items-center h-100">
        <div className="col-lg-12 mx-auto">
          <div className="bg-login">
            <div className="section-authentication-signin d-flex align-items-center justify-content-center my-5 my-lg-0">
              <div className="container-fluid">
                <div className="row row-cols-1 row-cols-lg-2 row-cols-xl-3">
                  <div className="col mx-auto">
                    <div className="card mb-0 new-bdr">
                      <div className="card-body new-bg">
                        <div className="p-4">
                          {/* Logo */}
                          <div className="mb-4 text-center">
                            <img
                              style={{ width: "180px" }}
                              src={`${image_baseurl}uploads/basicsetting/${information[0]?.logo}`}
                              alt="Logo"
                            />
                          </div>

                          {/* Login Method Selector */}
                          <div className="mb-4">
                            <div className="d-flex gap-2">
                              <button
                                type="button"
                                className={`btn flex-fill ${
                                  loginMethod === "otp"
                                    ? "btn-primary new-btn"
                                    : "btn-outline-secondary"
                                }`}
                                onClick={() => setLoginMethod("otp")}
                              >
                                Mobile OTP
                              </button>
                              <button
                                type="button"
                                className={`btn flex-fill ${
                                  loginMethod === "password"
                                    ? "btn-primary new-btn"
                                    : "btn-outline-secondary"
                                }`}
                                onClick={() => setLoginMethod("password")}
                              >
                                Email/Password
                              </button>
                            </div>
                          </div>

                          <div className="form-body lbl-colr">
                            {/* OTP Login Form */}
                            {loginMethod === "otp" && (
                              <form
                                className="row g-3"
                                onSubmit={handleSendOtp}
                              >
                                <div className="col-12">
                                  <label className="form-label">
                                    Mobile Number
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Enter Mobile Number"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                  />
                                </div>

                                <div className="col-12">
                                  <div className="d-grid">
                                    <button
                                      type="submit"
                                      className="btn btn-primary new-btn"
                                      disabled={isLoading}
                                    >
                                      {isLoading
                                        ? "Sending OTP..."
                                        : "Send OTP"}
                                    </button>
                                  </div>
                                </div>

                                <div className="col-12 text-center mt-3">
                                  <p className="mb-0">
                                    Don't have an account?{" "}
                                    <Link
                                      to="/register"
                                      className="btn btn-link text-light text-decoration-underline p-0"
                                    >
                                      Sign Up
                                    </Link>
                                  </p>
                                </div>
                              </form>
                            )}

                            {/* Email/Password Login Form */}
                            {loginMethod === "password" && (
                              <form className="row g-3" onSubmit={handleLogin}>
                                <div className="col-12">
                                  <label
                                    htmlFor="inputEmailAddress"
                                    className="form-label"
                                  >
                                    Email / Mobile
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="inputEmailAddress"
                                    placeholder="Enter Your Email"
                                    value={email}
                                    onChange={(e) => setemail(e.target.value)}
                                  />
                                </div>

                                <div className="col-12">
                                  <label
                                    htmlFor="inputChoosePassword"
                                    className="form-label"
                                  >
                                    Password
                                  </label>
                                  <div
                                    className="input-group"
                                    id="show_hide_password"
                                  >
                                    <input
                                      type={showPassword ? "text" : "password"}
                                      className="form-control border-end-0"
                                      id="inputChoosePassword"
                                      value={password}
                                      onChange={(e) =>
                                        setPassword(e.target.value)
                                      }
                                      placeholder="Enter Password"
                                    />
                                    <a
                                      href="javascript:;"
                                      onClick={togglePasswordVisibility}
                                      className="input-group-text bg-transparent bg-grn"
                                    >
                                      <i
                                        className={`bx ${
                                          showPassword ? "bx-show" : "bx-hide"
                                        }`}
                                      />
                                    </a>
                                  </div>
                                </div>

                                <div className="col-md-12">
                                  <p className="mb-0">
                                    <Link
                                      className="text-light text-decoration-underline"
                                      to="/forget-user"
                                    >
                                      Forgot Password?
                                    </Link>
                                  </p>
                                </div>

                                <div className="col-12">
                                  <div className="d-grid">
                                    <button
                                      type="submit"
                                      className="btn btn-primary new-btn"
                                      disabled={isLoading}
                                    >
                                      {isLoading ? "Signing In..." : "Sign In"}
                                    </button>
                                  </div>
                                </div>

                                <div className="col-12 text-center mt-3">
                                  <p className="mb-0">
                                    Don't have an account?{" "}
                                    <Link
                                      to="/register"
                                      className="btn btn-link text-light text-decoration-underline p-0"
                                    >
                                      Sign Up
                                    </Link>
                                  </p>
                                </div>
                              </form>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* OTP Modal */}
      {isOtpModalOpen && (
        <ReusableModal
          show={isOtpModalOpen}
          onClose={() => {
            setIsOtpModalOpen(false);
            setEnteredOtp("");
          }}
          title="Enter OTP"
          modalClass="modal-lg"
          body={
            <form>
              {/* <div
                className="row justify-content-center align-items-center"
                style={{ minHeight: "300px" }}
              >
                <div className="col-md-10 text-center">
                  <label className="fw-bold mb-4 fs-5">Enter OTP</label>

                  <div className="d-flex justify-content-between mt-3">
                    {Array.from({ length: 6 }, (_, i) => (
                      <input
                        key={i}
                        ref={(el) => (inputRefs.current[i] = el)}
                        type="text"
                        maxLength="1"
                        className="form-control text-center"
                        style={{
                          width: "60px",
                          height: "55px",
                          fontSize: "20px",
                          fontWeight: "600",
                        }}
                        value={enteredOtp[i] || ""}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, "");
                          const newOtp = enteredOtp.split("");
                          newOtp[i] = value;
                          setEnteredOtp(newOtp.join(""));

                          if (value && i < 5) {
                            inputRefs.current[i + 1].focus();
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Backspace") {
                            if (!enteredOtp[i] && i > 0) {
                              inputRefs.current[i - 1].focus();
                            }
                          }
                        }}
                      />
                    ))}
                  </div>
                </div>
              </div> */}

              <div
                className="row justify-content-center align-items-center"
                style={{ minHeight: "300px" }}
              >
                <div className="col-md-10 text-center">
                  <label className="fw-bold mb-4 fs-5">Enter OTP</label>

                  <div className="d-flex justify-content-between mt-3">
                    {Array.from({ length: 6 }, (_, i) => (
                      <input
                        key={i}
                        ref={(el) => (inputRefs.current[i] = el)}
                        type="text"
                        maxLength="1"
                        className="form-control text-center"
                        style={{
                          width: "60px",
                          height: "55px",
                          fontSize: "20px",
                          fontWeight: "600",
                        }}
                        value={enteredOtp[i] || ""}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, "");
                          const newOtp = enteredOtp.split("");
                          newOtp[i] = value;
                          setEnteredOtp(newOtp.join(""));

                          if (value && i < 5) {
                            inputRefs.current[i + 1].focus();
                          }
                        }}
                        onKeyDown={(e) => {
                          if (
                            e.key === "Backspace" &&
                            !enteredOtp[i] &&
                            i > 0
                          ) {
                            inputRefs.current[i - 1].focus();
                          } else if (e.key === "Enter") {
                            e.preventDefault();
                            handleOtpVerify();
                          }
                        }}
                      />
                    ))}
                  </div>

                  {/* 🔗 Resend OTP link */}
                  <div className="mt-4">
                    {canResendOtp ? (
                      <span
                        role="button"
                        className="fw-semibold text-primary"
                        style={{ cursor: "pointer" }}
                        onClick={handleResendOtp}
                      >
                        Resend OTP
                      </span>
                    ) : (
                      <span className="text-primary fw-semibold">
                        Resend OTP in {resendTimer}s
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </form>
          }
          footer={
            <>
              <button
                className="btn btn-light"
                onClick={() => setIsOtpModalOpen(false)}
              >
                Close
              </button>

              {/* <button
                className="btn btn-warning"
                onClick={handleResendOtp}
                disabled={isLoading}
              >
                {isLoading ? "Resending..." : "Resend OTP"}
              </button> */}

              <button className="btn btn-primary" onClick={handleOtpVerify}>
                Verify OTP
              </button>
            </>
          }
        />
      )}
    </div>
  );
};

export default Userlogin;
